import { Container, Grid } from "@mui/material";
import React from "react";
import CMC from "../../images/cmc.png"
import CG from "../../images/CG.png"

const Partner = () => {
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="pt-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">Partners</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center pt-4"
                    >
                        <img src={CMC} className="img-fluid d-inline-block mx-3" style={{height: 55, width: 'auto'}} />
                        <img src={CG} className="img-fluid d-inline-block mx-3" style={{height: 55, width: 'auto'}} />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Partner;